// de-DE
export default {
	title: "Geschenkkartenzentrum",
	myPoints: "Meine Punkte",
	SelectedGifts: "Ausgewählte Geschenke",
	form: {
		label: {
			title: "Suche",
			points: "Punkte"
		}
	},
	redemption: "Rückzahlung",
	stock: "Bestand",
	id: {
		redeemPoints: "Einlösen der erforderlichen Punkte:",
		btn: "Jetzt einlösen",
		title: "Kaufbenachrichtigung",
		content: `Sehr geehrter Mitarbeiter, vielen Dank für Ihre Teilnahme an der Arbeit.\n\nBitte lesen Sie die folgenden Bedingungen, bevor Sie Punkte einlösen:\n\n[Arbeitspunkte] Nach dem täglichen Abschluss der Optimierung der Auftragsdaten können Mitarbeiter 1 Geschenkpunkt verdienen kann für die teilweise Einlösung von Geschenksponsoring verwendet werden.\n[Geschenkeinlösung] Mitarbeiter müssen relevante Lieferadresseninformationen angeben und das Geschenk wird innerhalb von 14 Tagen weltweit kostenlos versendet. Nachdem die Einlösung abgeschlossen ist, können Sie sich an den Kundendienst wenden, um die Sendungsverfolgungsnummer zu erhalten und den Fortschritt des Geschenks zu verfolgen. Die Plattform gibt keine Informationen an Dritte weiter.\nHinweis: Sobald die Punkte gegen Geschenke eingelöst wurden, können sie nicht zurückerstattet werden`
	},
	applyDialog: {
		title: "Empfangsinformationen",
		form: {
			consignee: "Empfänger",
			area: "Bereich",
			telephone: "Telefon",
			deliveryAddress: "Lieferadresse"
		},
		btn: "Absenden"
	},
	records: {
		title: "Aufzeichnungen",
		status: ["Warten auf Versand", "Versandt", "Geliefert", "Storniert"]
	}
};
